import React, { useState } from "react";
import { Box, Button, Card, CardContent, TextField, Typography, InputAdornment, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import axios from 'axios';
import { hosturl } from "../libs/Constant.js";
import Signinlogo from "../../assets/signinlogo.png";

const LoginPage = () => {
  const navigate = useNavigate();
  
  // State hooks for form fields and error message
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false); // State for toggling password visibility

  const handleSignin = async () => {
    // Check if both fields are filled
    if (!email || !password) {
      setErrorMessage("Email and Password are required.");
      return;
    }
  
    try {
      // Make the API request to login
      const response = await axios.post(`${hosturl}/admin-login`, { email, password });
  
      // Check if the response status is 200 (successful)
      if (response.status === 200 && response.data.status) {
        const token = response.data.result.token; // Get token from the response
        const role = response.data.result.role;   // Get role from the response
  
        // Store token and role in localStorage
        localStorage.setItem('token', token);
        localStorage.setItem('role', role);
  
        // Redirect to dashboard or appropriate page
        navigate('/dashboard');
      } else {
        setErrorMessage("Failed to log in. Please try again.");
      }
    } catch (error) {
      console.error(error); // Log the error for debugging
  
      if (error.response) {
        // Handle errors returned from the server
        switch (error.response.status) {
          case 400:
            setErrorMessage("Email or password is incorrect.");
            break;
          case 404:
            setErrorMessage("Email doesn't exist. Please sign up.");
            break;
          case 500:
            setErrorMessage("Internal server error. Please try again later.");
            break;
          default:
            setErrorMessage("An unknown error occurred.");
        }
      } else if (error.request) {
        // If no response was received from the server
        setErrorMessage("No response received from the server. Please check your connection.");
      } else {
        // Other errors like request setup issues
        setErrorMessage("Error in setting up the request. Please check your connection.");
      }
    }
  };
  

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        background: "linear-gradient(to bottom, rgb(33, 31, 39), #E4DDEF)",
        height: '100vh',
        overflowY: 'auto',
      }}
    >
      {/* Left Side - Image & Gradient */}
      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: { xs: "20px", md: "0" },
        }}
      >
        <img
          src={Signinlogo}
          alt="Illustration"
          style={{ width: "30%", height: "auto" }}
        />
      </Box>

      {/* Right Side - Login Form */}
      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: { xs: "20px", md: "40px" },
          backgroundColor: 'white',
          borderStartStartRadius: '120px',
          borderBottomLeftRadius: '120px',
        }}
      >
        <Card
          sx={{
            width: { xs: "95%", sm: "380px" },
            padding: "30px",
            boxShadow: "none",
            borderRadius: "16px",
            border: "1px solid #ddd",
            marginX: "20px",
          }}
        >
          <CardContent>
            <Typography variant="h5" align="center" gutterBottom fontWeight={600} sx={{ marginBottom: '20px' }}>
              Log in
            </Typography>

            {/* Email and Password Fields */}
            <TextField 
              fullWidth 
              label="Email" 
              margin="normal" 
              variant="standard" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
            />
            <TextField 
              fullWidth 
              label="Password" 
              type={showPassword ? "text" : "password"}  // Toggle password visibility
              margin="normal" 
              variant="standard" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {/* Error Message */}
            {errorMessage && (
              <Typography 
                color="error" 
                align="center" 
                sx={{ marginTop: "10px", fontWeight: '500', fontFamily: 'poppins', fontSize:'15px' }}
              >
                {errorMessage}
              </Typography>
            )}

            {/* Log in Button */}
            <Button
              fullWidth
              variant="contained"
              onClick={handleSignin}
              sx={{
                marginTop: "20px",
                background: "#4caf50", // Use primary color for button
                borderRadius: "8px",
                textTransform: 'none',
              }}
            >
              Log in
            </Button>

          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default LoginPage;
